const { createSelector } = require('reselect');

/** Product-data flags for the viewed company; null while still unresolved. */
export const selectCompanyProducts = createSelector(
	state => state.main,
	main => main.companyProducts
);
